"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _package = require("../../package.json");

var _default = function _default() {
  return {
    version: 20130422,
    versionAPP: _package.version
  };
};

exports["default"] = _default;